const LSK = Object.freeze({
  calledCats: 'getCategoriesCalled',
  expandedCatsIds: 'expandedCategoriesIDs',
  expandedServIds: 'expandedServicesIDs',
  lastTimeCheckerReloaded: 'lastTimeReloadCheckerReloaded',
  locale: 'locale',
});

export default LSK;
